import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';
import { BaseLastNameInput } from 'src/components/enterprise/components/BaseLastNameInput/BaseLastNameInput';

export interface InvoiceContactLastNameControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export const InvoiceContactLastNameControl: React.FC<InvoiceContactLastNameControlProps> =
  ({ name, id, rules }) => {
    return (
      <BaseLastNameInput
        name={name}
        id={id}
        label={addAsterisk('Last Name', rules)}
        rules={rules}
      />
    );
  };
